import { RadioButtonControlProps } from "./RadioButtonControl.types";
import { useClassNames } from "../../../../structure";
import { Div, Label } from "../../../basic";
import { useTheme } from "../../../../structure";
export const RadioButtonControl = <T, P>({
  getValidationClassName,
  onRadioChange,
  control,
  formState,
  value,
  error,
}: RadioButtonControlProps<T, P>): React.ReactElement => {
  const classNames = useClassNames(
    ["formCheck", "bgNeutralLighterLight", "m-{0}", ...getValidationClassName()].concat(control.classNames || [])
  );
  const theme = useTheme();
  return (
    <Div classNames={["flex", "alignCenter", "justifyCenter", "gap-{8}"]}>
      <Div classNames={["flex", "flexRow", "alignCenter", "justifyCenter", "gap-{12}"]}>
        {control.options?.map((option) => (
          <Div classNames={["flex", "flexRow", "alignCenter", "justifyCenter", "gap-{12}"]} key={option.value}>
            <input
              type="radio"
              id={option.value}
              name={control.name}
              style={classNames}
              checked={value === option.value}
              onChange={onRadioChange}
              disabled={!!control.disabledIf && control.disabledIf(formState)}
              value={option.value}
            />
            <label
              key={option.value}
              htmlFor={option.value}
              style={{
                display: "flex",
                gap: "8px",
                alignItems: "center",
                justifyContent: "center",
                cursor: "pointer",
                color: "#fff",
                fontFamily: "Exo2",
              }}
            >
              {option.label}
            </label>
          </Div>
        ))}
      </Div>
      {error ? (
        <Label type="l4Regular" color={theme.theme.colors.danger.main}>
          {error}
        </Label>
      ) : null}
    </Div>
  );
};
